export default "__VITE_ASSET__Dhpi$Pls__"